import { createActionGroup, emptyProps } from "@ngrx/store";

export const classroomLifecycleEvents = createActionGroup({
    source: 'Classroom',
    events: {
        lessonHasBeenStopped: emptyProps(),
    }
});

export const classroomReceiverActions = createActionGroup({
    source: 'ReceiveFromClassroom',
    events: {
        receivedStopLessonCommand: emptyProps(),
    }
});
